var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHasAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.995 6.37a.648.648 0 00-.917-.024l-4.14 3.927-1.976-2.028a.648.648 0 10-.93.905l2.422 2.486a.646.646 0 00.911.018l4.606-4.367a.649.649 0 00.024-.917",
    stroke: "#F88801",
    fill: "#F88801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.703A6.71 6.71 0 012.297 9 6.71 6.71 0 019 2.297 6.71 6.71 0 0115.703 9 6.71 6.71 0 019 15.703M9 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8",
    stroke: "#195477",
    fill: "#195477"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasAccess);
export default __webpack_public_path__ + "static/media/has-access.656e3971.svg";
export { ForwardRef as ReactComponent };